import React from 'react';

const steps = [
  {
    num: '01',
    title: 'Add Your Card',
    desc: 'Connect your Visa, Mastercard or any debit or credit card to your Smile Africa account in under a minute.',
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2.5" />
        <path d="M2 10h20" />
        <path d="M6 15h4" />
      </svg>
    ),
  },
  {
    num: '02',
    title: 'Choose Country & Amount',
    desc: 'Select the recipient’s country and mobile network, enter their phone number, and pick an airtime amount.',
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="7" y="2" width="10" height="20" rx="2.5" />
        <path d="M11 18h2" />
      </svg>
    ),
  },
  {
    num: '03',
    title: 'Send Instantly',
    desc: 'Confirm the payment and the airtime lands on your loved one’s phone in seconds — no waiting, no hassle.',
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 2L11 13" />
        <path d="M22 2l-7 20-4-9-9-4 20-7z" />
      </svg>
    ),
  },
];

const HowItWorks: React.FC = () => {
  return (
    <section id="how-it-works" className="min-h-screen bg-black flex flex-col justify-center py-20">
      <div className="w-full px-[6vw]">

        {/* Title */}
        <h2
          className="text-center font-bold text-white mb-6"
          style={{ fontSize: 'clamp(2.2rem, 5vw, 4.5rem)' }}
        >
          How Smile Africa Works
        </h2>
        <p className="text-center text-gray-400 max-w-xl mx-auto mb-12">
          Three simple steps to send airtime to someone you love.
        </p>

        {/* Divider */}
        <div className="border-t border-gray-800 mb-12" />

        {/* Steps grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div key={step.num} className="group flex flex-col cursor-default rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1" style={{ background: '#161616' }}>

              {/* Icon */}
              <div
                className="w-16 h-16 rounded-2xl flex items-center justify-center mb-8 transition-transform duration-300 group-hover:scale-110"
                style={{ background: 'linear-gradient(135deg, #ff7233, #ea3d05)' }}
              >
                {step.icon}
              </div>

              {/* Step label */}
              <p className="text-sm font-bold tracking-widest uppercase mb-2" style={{ color: '#ff7233' }}>
                Step {step.num}
              </p>

              {/* Title */}
              <h3 className="text-white font-bold mb-3 transition-colors duration-200" style={{ fontSize: 'clamp(1.3rem, 2.2vw, 1.7rem)' }}>
                {step.title}
              </h3>

              {/* Description */}
              <p className="text-gray-400 text-base leading-relaxed">
                {step.desc}
              </p>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default HowItWorks;
